import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Profile } from 'assets/svg/icon-profile.svg'

function IconProfile(props: IconProps): JSX.Element {
  const title = 'icon-profile'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Profile {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconProfile
